import React, { useContext } from 'react'
import { flexRender } from '@tanstack/react-table'
import { UpArrow, DownArrow } from '../../Arrows'
import { PanelStyleContext } from '../../panel/PanelStyleContext'

export default ({ headerGroups }) => {
    const { headerIconClass } = useContext(PanelStyleContext)
    return (
        <thead className={'sticky-top'}>
            {headerGroups.map(headerGroup => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map(header => (
                        <th
                            key={header.id}
                            onClick={header.column.getToggleSortingHandler()}
                            style={{ cursor: header.column.getCanSort() ? 'pointer' : 'default' }}
                        >
                            <div className={`explorerTableHeader ${headerIconClass}`}>
                                {flexRender(header.column.columnDef.header, header.getContext())}
                                <span className="explorerTableArrow">
                                    {header.column.getIsSorted() ? (
                                        header.column.getIsSorted() === 'desc' ? (
                                            <DownArrow size={'1.1rem'} />
                                        ) : (
                                            <UpArrow size={'1.1rem'} />
                                        )
                                    ) : (
                                        ''
                                    )}
                                </span>
                            </div>
                        </th>
                    ))}
                </tr>
            ))}
        </thead>
    )
}
